
const UncheckedIcon = () => {
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Rectangle Copy 17</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPMobileFlyoutTrayJobDetailCopy12" transform="translate(-27, -532)" stroke="#6C7275" strokeWidth="2">
                    <g id="Group39Copy" transform="translate(7, 358)">
                        <g id="Group2" transform="translate(21, 134)">
                            <rect id="RectangleCopy17" x="0" y="41" width="18" height="18" rx="3"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default UncheckedIcon;
